import subjectSelectionService from "../../../../../services/subjectSelectionService";
import IconLock from "../../../../../assets/images/icons/circle-lock.svg?react";

const SubjectButton = (props) => {
    const {
        subjectsSelected,
        subject,
        packageProduct,
        onSubjectClick,
        isHigherSelection,
    } = props;

    const {
        isLocked,
        isSelected,
        isDisabled,
    } = subjectSelectionService.getSubjectVariant(
        subject,
        packageProduct,
        subjectsSelected,
        isHigherSelection,
    );

    return (
        <button
            type="button"
            disabled={isLocked || (isSelected ? false : isDisabled)}
            className={`selection-option selection-option--subject ${isSelected ? "selected" : ""} ${isLocked ? "locked" : ""}`}
            onClick={() => onSubjectClick(subject)}
        >
            {subject.name}
            {isLocked && <IconLock className="selection-option__lock" />}
        </button>
    );
};

export default SubjectButton;
